module.exports = "https://www.gc-qa.gnp.com.mx/7848298a1e59fc77c80563cc5674cc68.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/camera.png
// module id = 8066
// module chunks = 0